import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { VideoForm } from "app/interfaces/video-form.interface";

const videosSharedUrlApi = environment.videosSharedUrlApi;
const videosMySharedListUrlApi = environment.videosMySharedListUrlApi;
const videosMySharedOwnerListUrlApi = environment.videosMySharedOwnerListUrlApi;

@Injectable()
export class SharedVideoService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  private sortVideosByMostRecent(videos: any[] = []) {
    return [...videos].sort((a, b) => {
      const getTimestamp = (video: any) => {
        const rawValue = video?.start_time || video?.createdAt || null;
        const parsedValue = rawValue ? new Date(rawValue).getTime() : 0;
        return Number.isNaN(parsedValue) ? 0 : parsedValue;
      };

      const timestampDiff = getTimestamp(b) - getTimestamp(a);
      if (timestampDiff !== 0) {
        return timestampDiff;
      }

      return Number(b?.id_video || 0) - Number(a?.id_video || 0);
    });
  }

  /*   getSharedVideosByIdUser(id: number) {
    return this.http
      .request("GET", `${videosSharedUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  } */

  shareVideo(idUser: number, idVideo: number) {
    const body = { id_user: idUser, id_video: idVideo };
    return this.http
      .request("POST", `${videosSharedUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getMySharedVideosListByIdUser(id: number) {
    return this.http
      .request("GET", `${videosMySharedListUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(
        map((resp: any) => ({
          ...resp,
          data: this.sortVideosByMostRecent(resp?.data),
        }))
      );
  }

  getMySharedOwnVideosListByIdUser(id: number) {
    return this.http
      .request("GET", `${videosMySharedOwnerListUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(
        map((resp: any) => ({
          ...resp,
          data: this.sortVideosByMostRecent(resp?.data),
        }))
      );
  }

  deleteMySharedVideoById(id: number) {
    return this.http
      .request("DELETE", `${videosSharedUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }
}
